import styles from "./OverviewStatistics.module.scss";
import {
  CreditCard02Icon,
  MessageAlertSquareIcon,
  Rss01Icon,
  Users01Icon,
} from "@vetty/icons";
import { OverviewStatisticCard } from "..";

export const OverviewStatistics = () => {
  return (
    <div className={styles["comp"]}>
      <OverviewStatisticCard
        id="live-users"
        icon={<Rss01Icon style={{ width: 20, height: 20 }} />}
        heading="Active now"
        value="0"
        percentage="0"
        variant="none"
      />
      <OverviewStatisticCard
        id="total-accounts"
        icon={<Users01Icon style={{ width: 20, height: 20 }} />}
        heading="Total accounts"
        value="0"
        percentage="0"
        variant="none"
      />
      <OverviewStatisticCard
        id="members-joined"
        icon={<CreditCard02Icon style={{ width: 20, height: 20 }} />}
        heading="Members"
        value="0"
        percentage="0"
        variant="none"
      />

      <OverviewStatisticCard
        id="messages"
        icon={<MessageAlertSquareIcon style={{ width: 20, height: 20 }} />}
        heading="Messages"
        value="0"
        percentage="0"
        variant="none"
      />
    </div>
  );
};
